module.exports = __webpack_public_path__ + "media/images/mamari/wowma/flow-bg-red-33743ccc66a96682fd52b9190c242777.png";